import { useState, useCallback, useEffect } from "react";

import { ReactComponent as IconLoader } from "../../assets/icon-loader.svg";

const Autocomplete = ({
  className,
  value,
  placeholder = "",
  disabled = false,
  readOnly = false,
  onChange,
  onSelect,
  onBlur
}) => {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cursor, setCursor] = useState(0);

  const setOption = useCallback((option) => {
    setOptions([]);
    onSelect(option.value || option);
  }, [onSelect]);

  const handleKeyDown = (e) => {
    if (e.keyCode === 38 && cursor > 0) {
      setCursor(cursor - 1);
    } else if (e.keyCode === 40 && cursor < options.length - 1) {
      setCursor(cursor + 1);
    } else if (e.keyCode === 13) {
      e.preventDefault();
      options.length > 0 && !isNaN(cursor) && setOption(options[cursor]);
    }
  };

  const handleChange = useCallback((e) => {
    setCursor(0);
    setLoading(true);
    setInputValue(e.target.value);
    onChange(e, values => {
      setOptions(values);
      setLoading(false);
    });
  }, [onChange]);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <>
      <input type="text"
        className={className}
        value={inputValue}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        onBlur={onBlur}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      {loading && <IconLoader className="loader" />}
      {options.length > 0 && (
        <ul className="autocomplete">
          {options.map((option, i) => (
            <li
              key={i}
              className={`autocomplete__item ${cursor === i ? "item--active" : ""}`}
              onClick={() => setOption(option)}
            >
              {option.text || option}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default Autocomplete;
